










import { Component, Vue } from "vue-property-decorator";
import { Tab, Tabs } from 'vant';
import { getQueryParam } from "@/utils/index";
import FaqList from "@/components/FaqList.vue";

Vue.use(Tab);
Vue.use(Tabs);

@Component({
    components: {
        "v-faq-list": FaqList
    }
})
export default class FaqListPage extends Vue {
    cityId: number = 0;
    activeId: number = 0;

    sticky: boolean = true;

    tabList: any = [
        {
            id: 1,
            name: "贷款业务"
        },
        {
            id: 2,
            name: "提取业务"
        },
        {
            id: 3,
            name: "缴存业务"
        },
        {
            id: 4,
            name: "其他业务"
        }
    ];

    mounted() {
        let cityId: number = parseInt(this.$route.params.cityId);
        this.cityId = cityId;
    }
}
